import { useNavigate } from "react-router-dom";
import { ArrowLeft, Download } from "lucide-react";
import { Brand } from "../components/Brand";
import { DocText } from "../components/DocText";
import { BOOK_OF_ACTIVITIES, COPYRIGHT_DISCLAIMER } from "../lib/content";
import { printElement } from "../lib/report";

const WATERMARK =
  "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='420' height='320'><text x='20' y='170' font-family='Arial, sans-serif' font-size='22' fill='%231E293B' fill-opacity='0.05' transform='rotate(-30 210 160)'>SAA Analytics · Copra International LLC</text></svg>\")";

function Watermark() {
  return (
    <div className="pointer-events-none absolute inset-0 z-0">
      <div className="absolute inset-0" style={{ backgroundImage: WATERMARK, backgroundRepeat: "repeat" }} />
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: "url('/gcrc-logo.png')",
          backgroundRepeat: "repeat",
          backgroundSize: "180px 180px",
          opacity: 0.06,
        }}
      />
    </div>
  );
}

export default function BookOfActivities() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#F1F5F9]">
      <header className="no-print sticky top-0 z-10 border-b border-[#E2E8F0] bg-[#F1F5F9]/95 px-6 py-4 backdrop-blur sm:px-10">
        <div className="mx-auto flex max-w-3xl items-center justify-between">
          <Brand subtitle="Book of Activities" />
          <div className="flex items-center gap-2">
            <button onClick={() => printElement("#book-activities")} data-testid="download-book-btn"
              className="flex items-center gap-1.5 rounded-full bg-[#2563EB] px-4 py-2 text-sm font-semibold text-white transition-transform duration-200 hover:-translate-y-0.5">
              <Download className="h-4 w-4" strokeWidth={1.5} /> Download PDF
            </button>
            <button onClick={() => nav(-1)} data-testid="book-back-btn"
              className="flex items-center gap-1.5 text-sm text-[#1E293B]/70 transition-colors hover:text-[#2563EB]">
              <ArrowLeft className="h-4 w-4" strokeWidth={1.5} /> Back
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-6 py-10 sm:px-10">
        <div
          id="book-activities"
          className="relative overflow-hidden rounded-2xl border border-[#E2E8F0] bg-white p-8 sm:p-10"
          style={{ WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" }}
        >
          <div className="pointer-events-none absolute inset-0"><Watermark /></div>
          <div className="relative z-10">
            <DocText text={BOOK_OF_ACTIVITIES} />
            <p className="mt-10 border-t border-[#E2E8F0] pt-4 text-center text-[10px] leading-relaxed text-[#1E293B]/50">
              {COPYRIGHT_DISCLAIMER}
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
